import { useNavigate } from 'react-router-dom'
import { Bell } from 'lucide-react'
import { useUnreadCount } from '@/features/notification/api'
import { useAuthStore } from '@/stores/authStore'

export default function NotificationBell() {
  const navigate = useNavigate()
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  const { data: unreadCount } = useUnreadCount()

  if (!isAuthenticated) return null

  return (
    <button
      onClick={() => navigate('/mypage/notifications')}
      className="relative flex h-10 w-10 items-center justify-center rounded-full hover:bg-cb-gray-100 transition-colors"
      aria-label="알림"
    >
      <Bell size={22} className="text-cb-gray-700" />
      {unreadCount != null && unreadCount > 0 && (
        <span className="absolute -top-0.5 -right-0.5 flex h-5 min-w-5 items-center justify-center rounded-full bg-red-500 px-1 text-[10px] font-bold text-white">
          {unreadCount > 99 ? '99+' : unreadCount}
        </span>
      )}
    </button>
  )
}
